import { useEffect } from 'react';

const SCALAPAY_LOADER_SCRIPT_ID = 'scalapay-widget-loader';
const SCALAPAY_LOADER_SRC = 'https://cdn.scalapay.com/widget/scalapay-widget-loader.js?version=V5';

const loadScalapayLoaderScript = () => {
  if (typeof document === 'undefined' || document.getElementById(SCALAPAY_LOADER_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement('script');
  script.type = 'module';
  script.id = SCALAPAY_LOADER_SCRIPT_ID;
  script.src = SCALAPAY_LOADER_SRC;
  document.head.appendChild(script);
};

/**
 * Scalapay's "Suite" widget: shows the compact installment badge
 * (e.g. "from €33.33/month in 3 installments") next to a listing's price.
 *
 * Note: `type="product"` is the compact price badge; `type="checkout"` renders a
 * larger informational panel meant for the actual payment/checkout step, not a
 * listing page - Scalapay's own design for this placement uses "product".
 *
 * Also, Scalapay supports an `amount-selectors` attribute that scrapes the price
 * from DOM text, but its parsing is locale-sensitive (it expects a specific decimal
 * separator) and silently falls back to a placeholder amount (e.g. 100) if it can't
 * parse the text. We pass the numeric `amount` straight from OrderPanel's own price
 * data instead, with an explicit `amount-separator`, so the widget always reflects
 * the real price regardless of how it's formatted for display.
 */
const ScalapayWidget = props => {
  const { amount, locale, className } = props;

  useEffect(() => {
    loadScalapayLoaderScript();
  }, []);

  const merchantToken = process.env.REACT_APP_SCALAPAY_MERCHANT_TOKEN;
  const environment = process.env.REACT_APP_ENV === 'production' ? 'production' : 'integration';

  if (!merchantToken || !Number.isFinite(amount)) {
    return null;
  }

  return (
    <scalapay-widget
      className={className}
      type="product"
      amount={amount.toFixed(2)}
      amount-separator="."
      locale={locale}
      environment={environment}
      merchant-token={merchantToken}
    />
  );
};

export default ScalapayWidget;
